// Do not use outside of conversations-internal-schema. Instead use agentTypes in conversations-message-history/pubnub-message/constants/agentTypes"
export const HUMAN = 'HUMAN';
export const BOT = 'BOT';
export const AGENT = 'AGENT';